export default __webpack_public_path__ + "static/media/image.b4dce355.svg";